import { useEffect, useState } from "react";

function filmLive() {
  try {
    return new URLSearchParams(window.location.search).get("film") === "1";
  } catch {
    return false;
  }
}

function getSnapshot() {
  if (typeof window === "undefined") {
    return { width: 1200, isMobile: false, isTablet: false, isDesktop: true };
  }
  const width = window.innerWidth;
  const film = filmLive();
  return {
    width,
    isMobile: film ? width < 720 : width <= 480,
    isTablet: film ? false : width > 480 && width <= 900,
    isDesktop: film ? width >= 720 : width > 900,
  };
}

export function useResponsive() {
  const [snapshot, setSnapshot] = useState(getSnapshot);

  useEffect(() => {
    function onResize() {
      setSnapshot(getSnapshot());
    }
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return snapshot;
}
